import React from "react";
import {Tables} from "../../apitypes";
import useDownloadImage from "../storage/useDownloadImage";
import {Box, IconButton} from "@mui/material";
import Delete from "@mui/icons-material/Delete";

type RegImageProps = {
    image: Tables<"reg_images">
    onDelete: (image: Tables<"reg_images">) => void,
    regStatus: string
}
export default ({image, onDelete, regStatus}: RegImageProps) => {
    const avatar_url = useDownloadImage("registrations", image.image_url);

    return <Box sx={{position: "relative"}}>
        {regStatus != "RegFinished" &&
            <IconButton sx={{top: 0, position: "absolute", right: 0, color: "white"}}
                        onClick={() => onDelete(image)}><Delete/></IconButton>}
        <img src={avatar_url} alt={"Registracija"} style={{maxHeight: "200px", width: "auto"}}/>
    </Box>
}